import { ReactElement } from "react";
import { Navigate, useSearchParams } from "react-router";
import { AUTH_REDIRECT_SEARCH_PARAM } from "../../../common/constants";
import { Role } from "../../../common/security/enums";
import { DASHBOARD_ROUTE_PATHS } from "../../dashboard/paths";
import { useIsAuthenticated, useSelectedAccount } from "../hooks";

interface Props {
  component: ReactElement;
}

const LoginWrapper = ({ component }: Props) => {
  const [urlParams] = useSearchParams();
  const redirectParam = urlParams.get(AUTH_REDIRECT_SEARCH_PARAM);

  const selectedAccount = useSelectedAccount();
  const isUserAuthenticated = useIsAuthenticated();

  return isUserAuthenticated ? (
    <Navigate
      replace
      to={selectedAccount.role === Role.AGENT && redirectParam ? redirectParam : DASHBOARD_ROUTE_PATHS.homepage.to}
    />
  ) : (
    component
  );
};

export default LoginWrapper;
